$(document).ready(() => {

	const media = window.matchMedia("(max-width: 991px)");
	mobileSupport(media);
	media.addListener(mobileSupport);

	const setVh = () =>{
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
	setVh();
	window.addEventListener('resize', setVh);

	$("form.validation").validationEngine({
		showPrompts: false,
		addFailureCssClassToField: "error",
		scroll: false,
		onFieldFailure: function (field) {
			if (field) {
				if (field.is(":radio")) {
					$(field).closest(".radio").addClass("error");
				}
			}
		},
		onFieldSuccess: function (field) {
			if (field) {
				if (field.is(":radio")) {
					$(field).closest(".radio").removeClass("error");
				}
			}
		},
	});
	$("form.validation [class*=validate]").on("change blur keyup", function () {
		$(this).validationEngine("validate");
	});

	$("body").on("click", "form.ajax button[type=submit]", function (e) {
		e.preventDefault();
		postFormAjax($(this).closest("form"));
		return false;
	});

	$("[data-mask]").each(function () {
		const type = $(this).data("mask");
		switch (type) {
			case "phone":
				$(this).inputmask({
					showMaskOnHover: false,
					mask: "+\\9\\94 * ### ## ##",
					oncomplete: function () {
						const p = $(this).parent();
						if (!p.find("i.success").length)
							$("<i/>").addClass("success").appendTo(p);
						p.addClass("success");
					},
					onincomplete: function () {
						$(this).parent().removeClass("success");
					},
					onBeforeMask:function(value){
						value = value.replace(new RegExp(/[^0-9]/,'gi'),'');
						if(value.length === 12 && value.substring(0,3)==='994')value = value.substring(3);
						return value;
					},
					definitions: {
						"#": {
							validator: "[0-9]",
							cardinality: 1,
							casing: "lower",
						},
						"*": {
							validator: "(10|50|51|55|60|70|77|99)",
							cardinality: 2,
							prevalidator: [{validator: "[15679]", cardinality: 1}],
						},
					},
				});
				break;
			case "numeric":
			case "integer":
				$(this).inputmask(type, {rightAlign: false});
				break;
			case "cur":
				$(this).inputmask({
					suffix: " " + $(this).data("currency"),
					groupSeparator: ",",
					alias: "numeric",
					placeholder: "0",
					autoGroup: !0,
					digits: 2,
					digitsOptional: !1,
					clearMaskOnLostFocus: !1,
					rightAlign: false,
				});
				break;
		}
	});


	$("[data-match-height]").each(function () {
		$(this).find($(this).attr("data-match-height")).matchHeight();
	});
	const sliderButton = '<button></button>';
	if($('.homeSlider').length>0){
		const itemCount = $('.homeSlider .items > .item').length;
		$('.homeSlider .bttns .nav').attr('data-count', itemCount.toString().padStart(2, '0'));
		$('.homeSlider .bttns .nav').append(sliderButton.repeat(itemCount));
		const homeSlider = tns({
			container: '.homeSlider .items',
			navContainer: '.homeSlider .bttns .nav',
			controlsContainer: '.homeSlider .bttns .np',
			items: 1,
			slideBy: 'page',
			autoplay: true,
			nav: true,
			loop: true,
			autoplayButtonOutput: false,
			controls: true,
			controlsPosition:"bottom",
			navPosition:"bottom",
			autoplayHoverPause:true
		});
	}

	if($('.homeProjects').length>0){
		const itemCount = $('.homeProjects .items > .item').length;
		const buttonCount = $.isMobile ? itemCount : Math.ceil(itemCount/4);

		$('.homeProjects .sliderButton .nav').attr('data-count', buttonCount.toString().padStart(2, '0'));
		$('.homeProjects .sliderButton .nav').append(sliderButton.repeat(buttonCount));
		const homeProjects = tns({
			container: '.homeProjects .items',
			navContainer: '.homeProjects .sliderButton .nav',
			controlsContainer: '.homeProjects .sliderButton .np',
			items: 1,
			slideBy: 'page',
			autoplay: true,
			nav: true,
			loop: false,
			autoplayButtonOutput: false,
			controls: true,
			controlsPosition:"bottom",
			navPosition:"bottom",
			autoplayHoverPause:true,
			responsive: {
				991: {
					items: 4,
				}
			}
		});
	}
	if($('.projectPage').length>0){

		const homeProjects = tns({
			container: '.projectPage .slider',
			items: 1,
			slideBy: 'page',
			autoplay: true,
			nav: false,
			loop: false,
			autoplayButtonOutput: false,
			controls: true,
			controlsPosition:"top",
			controlsText:["",""],
			"gutter":20,
			autoplayHoverPause:true,
			responsive: {
				991: {
					items: 3,
				}
			}
		});
	}

	if($('.productPage').length>0){

		const productPage = tns({
			container: '.productPage .images .slider',
			navContainer: '.productPage .images .thumbnails',
			items: 1,
			slideBy: 'page',
			autoplay: false,
			nav: true,
			loop: false,
			autoplayButtonOutput: false,
			controls: true,
			controlsPosition:"bottom",
			navPosition:"bottom",
		});
	}

	const naviOpen = (li) =>{
		li.addClass('active');
		if($.isMobile){
			const ul = li.find('ul');
			ul.css('height', ul.find('li').toArray()
				.reduce((accumulator, item) => $(item).innerHeight() + accumulator, 0));
		}
		//$(document).on('click.navi', () => naviClose(li));
	};

	const naviClose = (li) =>{
		li.removeClass('active');
		if($.isMobile)li.find('ul').removeAttr('style');
		//$(document).off('click.navi', () => naviClose(li));
	};

	$('#header .navi > li:has(ul) > a').hover(function (e) {
		e.preventDefault();
		const li = $(this).parent();
		if (!li.hasClass('active')) {
			naviOpen(li);
			if (li.closest('.navi').find('>li.active').not(li).length > 0) {
				naviClose(li.closest('.navi').find('>li.active').not(li));
			}
			if(!$.isMobile)li.one('mouseleave', ()=>naviClose(li));
		} //else naviClose(li);
	}, $.noop);
	$('body').on('click', '#header .navi li.active', function (e) {
		e.stopPropagation();
	})


	const langOpen = (li) =>{
		li.addClass('active');
		//$(document).on('click.navi', () => naviClose(li));
	};

	const langClose = (li) =>{
		li.removeClass('active');
		//$(document).off('click.navi', () => naviClose(li));
	};

	$('#header .lang > a').hover(function (e) {
		e.preventDefault();
		const li = $(this).parent();
		if (!li.hasClass('active')) {
			langOpen(li);
			li.one('mouseleave', ()=>langClose(li));
		}
	}, $.noop);
	$('body').on('click', '#header .lang', function (e) {
		e.stopPropagation();
	})

	$('body').on('click', '#header .toggleMenu', function (e) {
		$('body').toggleClass('mobileMenu');
	})

	$('body').on('click', '#header .search button.open', function (e) {
		if($('.searchPage').length == 0)$('body').addClass('searchBox');
		if($.isMobile)$('body').toggleClass('mobileMenu');
	})
	$('body').on('click', '#header .search button.close', function (e) {
		$('body').removeClass('searchBox');
		if($.isMobile)$('body').toggleClass('mobileMenu');
	})
	$('body').on('click', '#searchBox button.clear', function (e) {
		$('#searchBox input').val('');
	})

	//tabs
	$('body').on('click','.tabs[data-target] > *:not(.active)',function(e){
		e.preventDefault();
		const tab_parent =  $(this).closest('.tabs'),
			target = tab_parent.attr('data-target');
		if(tab_parent.length > 0 && target){

			const tab = $(this),
				tabs = tab_parent.find('>*'),
				index = tabs.index(tab);

			$(target).each(function(){
				const content = $(this).find('>*')
				content.removeClass('active');
				content.eq(index).addClass('active');
			});

			tabs.removeClass('active');
			tab.addClass('active');
		}
	});



});

$.isMobile = false;
const mobileSupport = (media) => {
	if (media.matches) {
		$.isMobile = true;

		$(document).trigger("mobileOn");
	} else {
		$.isMobile = false;

		$(document).trigger("mobileOff");
	}
};
function postFormAjax(form) {
	if (form.validationEngine("validate") && form.attr("request") != 1) {
		let url = form.attr("action");

		const disabled = [];

		form.find(":disabled").each(function () {
			disabled.push(this);
			$(this).prop("disabled", false).removeProp("disabled");
		});
		let data = form.serialize();

		$.each(disabled, function () {
			$(this).prop("disabled", true);
		});

		$.ajax({
			url: url,
			type: "POST",
			dataType: "json",
			cache: false,
			data: data,
			beforeSend: function () {
				form.attr("request", 1);
				if (
					form.css("position") != "absolute" &&
					form.css("position") != "relative"
				)
					form.css("position", "relative");
				$(
					'<div class="loading"><div class="lds-ripple"><div></div><div></div></div></div>'
				).appendTo(form);
			},
			success: function (data) {
				form.attr("request", 0);
				if (data.code == 200) {
					form.addClass("success");
					form.find('button[type="submit"]').prop("disabled", true);
				} else if (typeof data.message != "undefined") {
					alertify.error(data.message);
				}
			},
			error: function (x, e) {
				form.attr("request", 0);
				var e_msg = "";
				if (x.status == 0)
					e_msg = "You are offline!!<br> Please Check Your Network.";
				else if (x.status == 404) e_msg = "Requested URL not found.";
				else if (x.status == 500)
					e_msg = "Internel Server Error." + x.responseText;
				else if (e == "parsererror")
					e_msg = "Error.<br>Parsing JSON Request failed.";
				else if (e == "timeout") e_msg = "Request Time out.";
				else if (e == "error") e_msg = "Request error.";
				else if (e == "abort") e_msg = "Request abort.";
				else e_msg = "Unknow Error.<br>" + x.responseText;
			},
			complete: function () {
				$(".loading").remove();
			},
		});
	}
}

